__turbopack_context__.v({
  "body": "TalesBlockIntro-module-scss-module__Svw1Fa__body",
  "content": "TalesBlockIntro-module-scss-module__Svw1Fa__content",
  "copy": "TalesBlockIntro-module-scss-module__Svw1Fa__copy",
  "eyebrow": "TalesBlockIntro-module-scss-module__Svw1Fa__eyebrow",
  "fade-in": "TalesBlockIntro-module-scss-module__Svw1Fa__fade-in",
  "headline": "TalesBlockIntro-module-scss-module__Svw1Fa__headline",
  "inner": "TalesBlockIntro-module-scss-module__Svw1Fa__inner",
  "isAboveFold": "TalesBlockIntro-module-scss-module__Svw1Fa__isAboveFold",
  "isInView": "TalesBlockIntro-module-scss-module__Svw1Fa__isInView",
  "root": "TalesBlockIntro-module-scss-module__Svw1Fa__root",
});
